import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.61 15.26a.76.76 0 0 1-.51-.2l-2.19-2.19A.76.76 0 1 1 9 11.81l1.63 1.62L15 9.07a.75.75 0 0 1 1 1.06l-4.75 4.77q-.05.074-.11.14a.77.77 0 0 1-.53.22" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }